<div class="container-fluid p-0 m-0">
  <div class="col-lg-12 m-0 grid-margin stretch-card p-2">
    <div class="bg-white rounded shadow">
      <div class="title-header"><h5 class="m-0 p-0">Add Campaign</h5></div>
      <div class="card-body container-body">
            <form [formGroup]="form"  class="form-horizontal ml-3" (ngSubmit)="onSubmit(success)">
                <fieldset>
                <div class="row">
                      <div class="col-md-7 mp-0">
                            <div class="row m-0 p-0">
                                  <div class="col-md-6 mp-0">
                                            <!-- Branch Name-->
                                            <div class="form-group">
                                                    <label>Campaign</label>  
                                                    <select #festival class="custom-select round" formControlName="festival_id" (change)="onFestivalChange(festival.value)">
                                                        <option value="">Select Campaign</option>
                                                        <option *ngFor="let data of FestivalDataLists" [value]="data.id">{{data.name}}</option>
                                                    </select>
                                                    <!-- error block -->
                                                    <div *ngIf="submitted && f.festival_id.errors" class="invalid-feedback">
                                                      <div *ngIf="f.festival_id.errors.required">Campaign is required</div>
                                                    </div> 
                                            </div>
                                  </div>
                                  <div class="col-md-6 mp-0">
                                              <!-- Branch Code-->
                                              <div class="form-group">
                                                      <label>Region</label>  
                                                        <select #region class="custom-select round" formControlName="region_id" (change)="onRegionChange(region.value)">
                                                          <option value="">Select Region</option>
                                                          <option *ngFor="let data of RegionDataLists" [value]="data.id">{{data.name}}</option>
                                                      </select>
                                                      <!-- error block -->
                                                      <div *ngIf="submitted && f.region_id.errors" class="invalid-feedback">
                                                        <div *ngIf="f.region_id.errors.required">Region is required</div>
                                                      </div> 
                                              </div>
                                  </div>                                                            
                            </div>  

                            <div class="row m-0 p-0">
                                <div class="col-md-12 mp-0">
                                    <div class="form-group">
                                      <label >Campaign Name:</label>
                                      <input id="" formControlName="name" type="text" class="form-control input-md" >
                                      <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Instore Name is required</div>
                                      </div>
                                    </div>
                                </div>
                              </div>
                            
                            <div class="row m-0 p-0">
                                  <div class="col-md-6 mp-0">
                                            <!-- Store Incharge-->
                                            <div class="form-group">
                                              <label>Showroom</label>
                                                  <select class="custom-select round" formControlName="showroom_id">
                                                      <option value="">Select Showroom</option>
                                                      <option *ngFor="let data of FilterShowroomLists" [ngValue]="data.id">{{data.name}}</option>
                                                  </select>
                                                  <!-- error block -->
                                                  <div *ngIf="submitted && f.showroom_id.errors" class="invalid-feedback">
                                                    <div *ngIf="f.showroom_id.errors.required">Showroom is required</div>
                                                  </div> 
                                            </div>
                                  </div>
                                  <div class="col-md-6 mp-0">
                                            <!-- Location-->
                                            <div class="form-group">
                                                    <label>Asset Type</label>  
                                                    <select class="custom-select round" formControlName="asset_type_id">
                                                        <option value="">Select Asset Type</option>
                                                        <option *ngFor="let data of AssetsDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                    </select>
                                                    <!-- error block -->
                                                    <div *ngIf="submitted && f.asset_type_id.errors" class="invalid-feedback">
                                                      <div *ngIf="f.asset_type_id.errors.required">Asset Type is required</div>
                                                    </div> 
                                            </div>
                                  </div>
                            </div>    
                            
                            <div class="row m-0 p-0">
                                    <div class="col-md-6 mp-0">
                                              <!-- Asset Type -->
                                              <div class="form-group">
                                                      <label>Creative</label>  
                                                      <select class="custom-select round" formControlName="creative_id">
                                                          <option value="">Select Creative</option>
                                                          <option *ngFor="let data of CreativeDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                      </select>
                                                      <!-- error block -->
                                                      <div *ngIf="submitted && f.creative_id.errors" class="invalid-feedback">
                                                        <div *ngIf="f.creative_id.errors.required">Creative is required</div>
                                                      </div> 
                                              </div>
                                    </div>
                                    <div class="col-md-6 mp-0">
                                              <!-- Add Cost -->
                                              <div class="form-group">
                                                      <label>Add Cost</label>  
                                                      <input id="contact" formControlName="cost" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.cost.errors }">
                                                      <div *ngIf="submitted && f.cost.errors" class="invalid-feedback">
                                                          <div *ngIf="f.cost.errors.required">Cost is required</div>
                                                      </div> 
                                              </div>
                                    </div>
                            </div>  

                            <div class="row m-0 p-0">
                                    <div class="col-md-6 mp-0">
                                          <div class="form-group">
                                                <label >Asset Size - Width :</label>
                                                <input id="contact" formControlName="size_w" type="text" placeholder="" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.size_w.errors }">
                                                <div *ngIf="submitted && f.size_w.errors" class="invalid-feedback">
                                                <div *ngIf="f.size_w.errors.required">Width is required</div>
                                                </div> 
                                          </div>
                                    </div>
                                    <div class="col-md-6 mp-0">
                                          <div class="form-group">
                                                <label >Asset Size - Height :</label> 
                                                <input id="contact" formControlName="size_h" type="text" placeholder="" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.size_h.errors }">
                                                <div *ngIf="submitted && f.size_h.errors" class="invalid-feedback">
                                                <div *ngIf="f.size_h.errors.required">Height is required</div>
                                                </div>                                     
                                          </div>
                                    </div>
                            </div>  

                            <div class="row m-0 p-0">
                                    <div class="col-md-6 mp-0">
                                            <!-- Date -->
                                            <div class="form-group">
                                                  <label>Installation Date</label>                         
                                                    <input class="form-control-date" matInput [matDatepicker]="pickerinstallation" placeholder="" formControlName="install_date" (dateChange)="installChange($event)">
                                                    <mat-datepicker-toggle matSuffix [for]="pickerinstallation"></mat-datepicker-toggle>
                                                    <mat-datepicker #pickerinstallation></mat-datepicker>
                                                    <div *ngIf="submitted && f.install_date.errors" class="invalid-feedback">
                                                    <div *ngIf="f.install_date.errors.required">Installation Date is required</div>
                                                  </div> 
                                            </div>
                                    </div>
                                    <div class="col-md-6 mp-0">
                                              <!-- Remarks -->
                                              <div class="form-group">
                                                      <label>Expiry Date</label>  
                                                        <input [disabled]="form.controls['install_date'].hasError('required')" class="form-control-date" matInput [matDatepicker]="pickerexpiry" placeholder="" formControlName="expiry_date" [min]="minDate">
                                                        <mat-datepicker-toggle matSuffix [for]="pickerexpiry"></mat-datepicker-toggle>
                                                        <mat-datepicker #pickerexpiry></mat-datepicker>
                                                      <div *ngIf="submitted && f.expiry_date.errors" class="invalid-feedback">
                                                        <div *ngIf="f.expiry_date.errors.required">Expiry Date is required</div>
                                                      </div> 
                                                </div>
                                    </div>
                            </div> 
                            
                            <div class="row m-0 p-0">
                                  <div class="col-md-6 mp-0">
                                          <!-- Remarks -->
                                          <div class="form-group">
                                                <label class="col-md-3 control-label ml-0 mt-2" for="contact">Particulars</label>  
                                                <textarea class="form-control" rows="4" id="comment" id="contact" formControlName="particulars" type="text" class="form-control input-md" [ngClass]="{ 'is-invalid': submitted && f.particulars.errors }"></textarea>  
                                                <div *ngIf="submitted && f.particulars.errors" class="invalid-feedback">
                                                  <div *ngIf="f.particulars.errors.required">Particulars is required</div>
                                                </div> 
                                          </div>
                                  </div>
                                  <div class="col-md-6 mp-0">
                                          <!-- Add Vendor -->
                                          <div class="form-group">
                                                  <label class="col-md-3 control-label ml-0 mt-2" for="contact">Vendor</label>  
                                                  <select class="custom-select round" formControlName="vendor_id">
                                                      <option value="">Select Vendor</option>
                                                      <option *ngFor="let data of VendorDataListsl" [ngValue]="data.id">{{data.name}}</option>
                                                  </select>
                                                  <!-- error block -->
                                                  <div *ngIf="submitted && f.vendor_id.errors" class="invalid-feedback">
                                                    <div *ngIf="f.vendor_id.errors.required">Vendor is required</div>
                                                  </div> 
                                          </div>
                                          <a href="#" class="tag">Add New Vendor</a>
                                  </div>
                            </div>  
                      </div>  

                      <div class="col-md-5 mp-0">
                        <label class="label-header">Campaign Image:</label>
                        <div class="uploader">
                          <input id="file-upload" type="file" name="fileUpload" accept="image/*" (change)="onFileChange($event)"/>
            
                          <label for="file-upload" id="file-drag">
                            <img [src]="imageSrc" *ngIf="imageSrc"  id="file-image">
                            <div id="start" *ngIf="!imageSrc">
                              <i class="fa fa-download" aria-hidden="true"></i>
                              <div class="label-header">Select a file</div>
                            </div>
                          </label>
                        </div>
                        <div class="text-center mt-4">
                          
                          <button class="btn btn-success mt-4 mr-3 btn-w">Save</button>
                          <button  class="btn btn-secondary btn-w mt-4" type="reset" (click)="onReset()">Reset</button>
                        </div>
                      </div> 
                </div>    
                </fieldset>
            </form>
      </div>  
    </div>
  </div>  
</div>

<ng-template #success let-modal class="mp-0">
  <div class="p-2">
    <div class="modal-header justify-content-center">
      <div class="icon-box mx-auto">
        <i class="fa fa-check fa-5x  text-white" aria-hidden="true"></i>
      </div>
    </div>
    <div class="modal-body text-center">
      <h5>New Campaign has been added successfully.</h5>
      <button class="btn btn-okay" (click)="modal.dismiss('Cross click')"><span>Ok</span></button>
    </div>
  </div> 
</ng-template>

<ngx-spinner type="ball-spin-clockwise" ></ngx-spinner>
